// Module
var code = "<p>module.exports = <strong>webpack_public_path</strong> + &quot;img/youtube_icon.691659b2.png&quot;;</p> ";
// Exports
module.exports = code;